module.exports = __webpack_public_path__ + "static/media/add.20dd8fae.png";